import { WorldTimeItem } from '@/entities/world-time';
import { useTimezoneStore } from '@/entities/world-time/model/store';
import { EditWorldTimeModal } from '@/entities/world-time/ui/EditWorldTimeModal';

import { openModal } from '@/shared/lib';
import { Header } from '@/shared/ui';

export const WorldTimeWidget = () => {
  const timeZones = useTimezoneStore((state) => state.selected);
  return (
    <div className="flex h-full w-full flex-col">
      <Header
        className="pb-6"
        title="World time"
        action={{
          as: 'button',
          label: 'Edit',
          onClick: () => {
            openModal({ id: 'edit-time-modal', component: EditWorldTimeModal });
          },
        }}
      />

      <div className="flex w-full flex-col gap-y-3">
        {timeZones.map((timeZone, idx) => (
          <WorldTimeItem {...timeZone} key={idx} />
        ))}
      </div>
    </div>
  );
};
